import React, { useReducer, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";
import { authenticationService } from "../services/authentication.service";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

//auth
import { login, logout, register } from "./functions/AuthFunction";
import { authReducer, initialAuthState } from "./reducers/AuthReducer";

//common
import { fun1, fun2 } from "./functions/CommonFunction";
import { commonReducer, initialCommonState } from "./reducers/CommonReducer";

export const DContext = React.createContext();

export const DProvider = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [authState, authDispatch] = useReducer(authReducer, initialAuthState);
  const [commonState, commonDispatch] = useReducer(
    commonReducer,
    initialCommonState,
  );

  useEffect(() => {
    console.log("Dcontext started with api", API_BASE_URL);
    loadUser();
  }, []);

  const loadUser = async () => {
    try {
      let token = localStorage.getItem("token");
      if (!token) {
        authDispatch({ type: "LOGOUT" });
      } else {
        //make a call to server using token and fetch the detail to keep in context
        const axiosRes = await axios({
          method: "GET",
          headers: { "x-access-token": token },
          url: `${API_BASE_URL}/users/verify-token`,
        });
        if (axiosRes.data.statusCode == 200) {
          console.log("loadUser [SUCCESS]", axiosRes.data);
          // same menu source as Login; fetched before USER_LOADED so the sidebar renders with the full menu
          const menuRes = await authenticationService.getMenuAccess(
            axiosRes.data.resData.user_info.role_code,
            token,
          );
          authDispatch({
            type: "USER_LOADED",
            payload: axiosRes.data.resData.user_info,
          });
          authDispatch({
            type: "PROFILE_LOADED",
            payload: axiosRes.data.resData.profile_res,
          });
          authDispatch({
            type: "MENU_LOADED",
            payload: menuRes?.success
              ? menuRes.resData
              : axiosRes.data.resData.menu_access,
          });
          authDispatch({
            type: "USER_ROLE_LOADED",
            payload: axiosRes.data.resData.role_info,
          });
          //navigate('/'); // ye rha to refresh krne pr hr waqt home page pr chala jayega
        } else {
          localStorage.removeItem("token");
          authDispatch({ type: "LOGOUT" });
        }
      }
    } catch (err) {
      console.log("loadUser [ERROR]", err);
      const status = err?.response?.status;
      // drop the token only when the server rejects it, not on network errors
      if (status === 401 || status === 403) {
        localStorage.removeItem("token");
      }
      authDispatch({ type: "LOGOUT" });
    }
  };

  return (
    <DContext.Provider
      value={{
        // auth Reducer state
        authState,
        authDispatch,
        // auth global functions
        login,
        register,
        logout,

        // auth Reducer state
        commonState,
        commonDispatch,
        // auth global functions
        fun1,
        fun2,
      }}
    >
      {props.children}
    </DContext.Provider>
  );
};

export default DContext;
